import { IIdTitle, IdTitle } from "ui/Scripts/source/models/common/idTitle";
import { Base } from "ui/Scripts/source/framework/base";
import { DocumentDocumentEditItem, IDocumentDocumentEditItem } from "./documentDocumentEditItem";

export interface IDocumentDcoumentEdit {
    path: string;
    keywords: IIdTitle[];
    item: IDocumentDocumentEditItem;
}

export class DocumentDcoumentEdit implements IDocumentDcoumentEdit {
    path: string;
    keywords: IdTitle[];
    item: DocumentDocumentEditItem;

    constructor();
    constructor(obj: IDocumentDcoumentEdit);
    constructor(obj?: any) {
        this.path = obj && obj.path || "";
        this.keywords = Base.getTypedArray(obj ? obj.keywords : null, IdTitle);
        this.item = new DocumentDocumentEditItem(obj ? obj.item : null);
    }
}